export const Niveles = [
    {"id_nivel": 1, "desc_nivel": "Fin"},
    {"id_nivel": 2,"desc_nivel": "Proposito"},
    {"id_nivel": 3, "desc_nivel": "Componente"},
    {"id_nivel": 4, "desc_nivel": "Actividad"},
    {"id_nivel": 5,"desc_nivel": "FID"}]
